import { useEffect } from 'react';

import { useFocusPoint } from 'entities/map';
import { useMapContext } from 'entities/map';

export const useUpdateFocusPoint = () => {
  const { setZoom, setCenter } = useMapContext();
  const focusPoint = useFocusPoint();

  useEffect(() => {
    if (focusPoint) {
      const { longitude, latitude, zoom } = focusPoint;

      setCenter({ lng: longitude, lat: latitude });
      if (zoom) setZoom(zoom);
    }
  }, [
    focusPoint,
    setCenter,
    setZoom
  ]);
};

